import { render, staticRenderFns } from "./TableTitle.vue?vue&type=template&id=2dc46bdc&"
import script from "./TableTitle.vue?vue&type=script&lang=js&"
export * from "./TableTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports